<template>
    <skeleton-wrapper :is-loading="isLoading">
        <template v-slot:skeleton>
            <multime-widget-skeleton />
        </template>
        <template v-slot:content>
            <div class="h-100">
                <actionable-card
                    v-if="exercise.id !== null && hasRoles"
                    primary-title="MultiMe"
                    :title="trans('widgets.multime.done.title')"
                    :description="trans('widgets.multime.done.description')"
                    :button-text="exercise.isDone ? trans('widgets.multime.done.do_again') : trans('widgets.multime.continue')"
                    :secondary-button-text="exercise.isDone ? trans('widgets.multime.done.see_results') : null"
                    secondary-button-variant="link"
                    buttonSize="sm"
                    @primaryClicked="exercise.isDone ? restartExercise() : openModal()"
                    @secondaryClicked="exercise.isDone ? openResult(exercise.id) : openResult(exercise.id)"
                >
                    <template v-slot:extra-body>
                        <multime-widget-card-content
                            :is-done="true"
                            :hasRoles="hasRoles"
                            :roles="roles"
                            imgSrc="/images/multicircle/multime-dashboard.svg"
                            logoSrc="/images/multicircle/Kellogg_logo.svg"
                        />                    
                    </template>
                </actionable-card>

                <actionable-card
                    v-else
                    :primary-title="trans('widgets.multime.start.title')"
                    :description="trans('widgets.multime.start.description')"
                    :button-text="trans('widgets.multime.start.start_now')"
                    :secondary-button-text="trans('widgets.multime.start.read_more')"
                    secondary-button-variant="link"
                    buttonSize="sm"
                    @primaryClicked="openStartModal"
                    @secondaryClicked="openMultime"
                    :is-disabled="cardNotStartedIsDisabled"
                >
                    <template v-slot:extra-body>
                        <multime-widget-card-content
                            :is-done="exercise.isDone"
                            :hasRoles="hasRoles"
                            imgSrc="/images/multicircle/multime-dashboard.svg"
                            logoSrc="/images/multicircle/Kellogg_logo.svg"
                        />
                    </template>
                </actionable-card>
                <multi-me-modal @exerciseCompleted="closeModal" @goToResult="openResult(exercise.id)" @hideMultimeModal="onHideModal" />
            </div>
        </template>
    </skeleton-wrapper>
</template>

<script>
    import ActionableCard from "../../../molecules/cards/ActionableCard";
    import MultiMeModal from "../../multime/MultiMeModal";
    import MultimeWidgetCardContent from "./MultimeWidgetCardContent";
    import {mapMutations, mapActions, mapGetters} from "vuex";
    import SkeletonWrapper from "../../../organisms/SkeletonWrapper";
    import MultimeWidgetSkeleton from "../../../molecules/skeletons/MultimeWidgetSkeleton";

    export default {
        name: "MultimeWidget",
        components: {
            ActionableCard,
            MultiMeModal,
            MultimeWidgetCardContent,
            SkeletonWrapper,
            MultimeWidgetSkeleton
        },
        data() {
            return {
                cardNotStartedIsDisabled: false
            }
        },
        methods: {
            ...mapActions({
                fetchLastExercise: 'multime/fetchLastExercise',
                createExercise: 'multime/createExercise'
            }),
            ...mapMutations({
                setCurrentExercise: 'multime/setCurrentExercise',
                setCharacteristicsList: 'multime/setCharacteristicsList',
                initCharacteristics: 'multime/initCharacteristics',
                clearExercise: 'multime/clearExercise'
            }),
            async openModal(){
                if(this.exercise.id === null){
                    await this.createExercise({type: 'standalone', pageId: 0});
                }
                this.$bvModal.show('multime-modal')
                if (this.exercise.isDone) {
                    trackEvent('MultiMeWidgetContinue', {})
                } else {
                    trackEvent('MultiMeWidgetStart', {})
                }
            },
            onHideModal() {
                this.cardNotStartedIsDisabled = false
            },
            closeModal(){
                this.$bvModal.hide('multime-modal')
            },
            openResult(resultId){
                this.$router.push({ name: 'multimeResult', params: { id: resultId } })
                trackEvent('MultiMeWidgetResults', {})
            },
            openMultime(){
                this.$router.push({ name: 'multime' })
                trackEvent('MultiMeWidgetOpenMultimeDetails', {})
            },
            restartExercise() {
                this.clearExercise()
                this.openModal()
            },
            openStartModal(){
                this.cardNotStartedIsDisabled = true
                this.openModal()
            }
        },
        mounted() {
            this.fetchLastExercise();
        },
        
        computed: {
            ...mapGetters({
                exercise: 'multime/getCurrentExercise',
                isLoading: 'multime/getLoading',
                roles: 'multime/getSavedRoles'
            }),
            hasRoles() {
                return this.roles.length > 0
            }
        }
    }
</script>